import React, { useState, useEffect } from 'react';
import { Eye } from 'lucide-react';
import { Link } from 'react-router-dom';
import AdminAppBody from '../../../../components/admin/AdminAppBody';
import useApiCallHooks from '../../../../hooks/useApiCallHooks';
import { apiRoutes } from '../../../../routes/api/apiRoutes';

const TaskList = () => {
  const [search, setSearch] = useState('');
  const [response, loading, error, callAPI] = useApiCallHooks();
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    callAPI('get', 'mentor/task-list');
  }, []);

  useEffect(() => {
    if (response?.data) {
      setTasks(response.data);
    }
  }, [response]);

  const filteredTasks = tasks.filter((task) => {
    const moduleName = task.module?.name || '';
    const topic = task.topic || '';
    return (
      moduleName.toLowerCase().includes(search.toLowerCase()) ||
      topic.toLowerCase().includes(search.toLowerCase())
    );
  });

  return (
    <AdminAppBody
      loading={loading}
      content={
        <div className="p-4">
          <div className="d-flex justify-content-end mb-3">
            <Link to="/mentor/add-task">
              <button className="custom-btn-blue">+ Create Task</button>
            </Link>
          </div>

          <div className="card border-0 shadow">
            <div className="card-body">
              <h4 className="fw-bold mb-3">Tasks</h4>

              <div className="d-flex justify-content-end mb-3">
                <input
                  type="text"
                  className="form-control w-25 me-2"
                  placeholder="Search"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
                <button className="custom-btn-blue">Search</button>
              </div>

              <table className="table text-center align-middle">
                <thead style={{ backgroundColor: '#dceeff' }}>
                  <tr>
                    <th>Sr No</th>
                    {/* <th>Program</th> */}
                    <th>Module</th>
                    <th>Topic</th>
                    <th>Total Tasks</th>
                    <th>View</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredTasks.length > 0 ? (
                    filteredTasks.map((task, index) => (
                      <tr key={task.id}>
                        <td>{index + 1}</td>
                        {/* <td>{task.program || '-'}</td> */}
                        <td>{task.module?.name || '-'}</td>
                        <td>{task.topic?.name || '-'}</td>
                        <td>{task.tasks?.length || 1}</td>
                        <td>       
                        
                          <Link to={`/mentor/edit-task/${task.id}`}>
                         

                            <button className="custom-btn-outline d-flex align-items-center justify-content-center gap-1 mx-auto">
                              <Eye size={16} />
                              View Task
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6">No tasks found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <style>{`
            .custom-btn-blue {
              background-color: #004AAD;
              color: white;
              border: 1.5px solid #004AAD;
              padding: 6px 14px;
              font-weight: 500;
              border-radius: 6px;
              transition: 0.3s ease;
            }
            .custom-btn-blue:hover {
              background-color: white;
              color: #004AAD;
              border-color: #004AAD;
            }
            .custom-btn-outline {
              background-color: white;
              color: #004AAD;
              border: 1.5px solid #004AAD;
              padding: 6px 14px;
              font-weight: 500;
              border-radius: 6px;
              transition: 0.3s ease;
            }
            .custom-btn-outline:hover {
              background-color: #004AAD;
              color: white;
            }
          `}</style>
        </div>
      }
    />
  );
};

export default TaskList;
